import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AnimationOptions } from 'ngx-lottie';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CategoriasService } from 'src/app/services/categorias.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-intereses',
  templateUrl: './intereses.component.html',
  styleUrls: ['./intereses.component.scss']
})
export class InteresesComponent implements OnInit {

  @Output() close = new EventEmitter<boolean>();

  categorias!: Observable<any[]>;
  categoriasSelected: any[] = [];

  userId!: any;
  isMobile: boolean = false;
  loadingPage: boolean = false;

  @ViewChild('containerEvents', { static: false }) containerEvents: ElementRef;
  loadingLottie: AnimationOptions = {
    path: 'assets/lotties/loading.json',
  };

  constructor(private categoriasService: CategoriasService, private userService: UserService,
    private auth: AuthenticationService, private router: Router, private location: Location, private dialog: MatDialog) {
    this.userId = this.auth.user;
  }

  ngOnInit(): void {
    this.loadingPage = true;
    this.isMobile = window.innerWidth <= 900;
     this.categoriasService.getAllCategories().subscribe((resp) => {
      this.categorias = resp;
      console.log('Categorías cargadas correctamente', this.categorias);
      this.userService.getPreferencias().subscribe(res => {
        this.categoriasSelected = res
        this.loadingPage = false;
      }, error => {
        this.loadingPage = false;
        this.dialog.open(InfoCardComponent, {
          panelClass: 'info-dialog',
          data: {
            icon: false,
            text: 'Error al cargar las preferencias del usuario',
            btnCancel: false
          }
        });
      });
    }, error => {
      this.loadingPage = false;
      this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: false,
          text: 'Error al cargar las categorías',
          btnCancel: false
        }
      });
    }
    );
  }

  selectCategory(category: any) {
    const index = this.categoriasSelected.findIndex(value => value == category['@id']);
    index != -1 ? this.categoriasSelected.splice(index, 1) : this.categoriasSelected.push(category['@id']);
  }

  savePreferences() {
    this.userService.putUser(this.userId, { preferencias: this.categoriasSelected }).subscribe({
      next: (res) => {
        this.router.navigate(["/profile"]).then(() => {
          this.dialog.open(InfoCardComponent, {
            panelClass: 'info-dialog',
            data: {
              icon: false,
              text: 'Se han guardado los cambios correctamente',
              btnCancel: false
            }
          });
        });
      }
    })
  }

  goBack() {
    this.location.back();
  }
}
